import {createValidationMessage} from '../../../../validation/create-validation-message'

const isReasonSelected = (lastImageVersion) => {
    if (!lastImageVersion.meta) {
        return false;
    }
    if (!lastImageVersion.meta.reason) {
        return false;
    }

    return true;
}

export default (task, processInstance, taskName, eventName, imageVersionList) => {
    if (eventName !== 'new_photos_needed') {
        return null
    }

    const messageList = []

    let reasonSelected = false;
    for (let key in imageVersionList) {
        let imageVersionGallery = imageVersionList[key];
        let lastImageVersion = imageVersionGallery[imageVersionGallery.length - 1];

        if (isReasonSelected(lastImageVersion)) {
            reasonSelected = true;
            break;
        }
    }

    if (!reasonSelected) {
        messageList.push(
            createValidationMessage(
                "At least one reason must be provided.",
                "newPhotosNeededReasonNotSelected.newPhotosNeededReasonNotSelected"
            )
        )
    }

    return messageList
}



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/treatment/new-photos-needed-validator.js